<template>
	<div>
		<v-snackbar v-model="dailyScrumSavedNotif" top>
					Daily Scrum Saved
					<v-btn color="pink" flat @click="dailyScrumSavedNotif = false">
						Close
					</v-btn>
				</v-snackbar>

		<v-card class="mb-4">
			<v-toolbar flat dense cad>
				<v-toolbar-title class="subheading">
					Daily Scrum
					<span class="info-text"> - {{ dailyScrum.scrumDateUtc | formatDate('dddd, DD MMM YYYY') }}</span>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-items>
					<v-btn v-if="todaysScrum" small flat @click="dailyScrumEditorDialog = true">
						<v-icon class="mr-2">edit</v-icon> Edit</v-btn>
				</v-toolbar-items>
			</v-toolbar>
			<v-divider></v-divider>

			<v-card-text class="text-xs-left">
				<div v-if="todaysScrum">
					<daily-scrum :dailyScrum="todaysScrum" />
				</div>
				<div v-else class="mt-1 mb-4">
					{{greetingMessage}}<a href="#" @click="dailyScrumEditorDialog = true">Fill out your daily scrum</a>
				</div>

				<div v-if="todaysDailyScrumsForMyTeam.length > 0">
					<v-divider />
					<team-daily-scrums :dailyScrums="todaysDailyScrumsForMyTeam" />
				</div>

			</v-card-text>

		</v-card>

		<v-dialog v-model="dailyScrumEditorDialog" persistent max-width="1000px">

			<daily-scrum-editor
			 		v-if="dailyScrumEditorDialog"
					:dailyScrum="dailyScrum" 
					:lastDailyScrum="lastScrum" 
					:loggedInEmployee="loggedInEmployee" 
					:isSubmitting="isSubmitting" 
					@save="onSave" 
					@onCancel="onCancel" />

		</v-dialog>

	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import greetingsMixin from '@/mixins/greetingsMixin';
	import DailyScrumEditor from '@/components/dailyScrum/DailyScrumEditor';
	import DailyScrum from '@/components/dailyScrum/DailyScrum';
    import TeamDailyScrums from '@/components/dailyScrum/TeamDailyScrums'

	export default {
		data() {
			return {
				dailyScrumEditorDialog: false,
				dailyScrum: null,
				dailyScrumSavedNotif: false,
				isSubmitting: false
			};
		},
		components: {
			DailyScrumEditor,
			DailyScrum,
			TeamDailyScrums
		},
		created() {
			this.dailyScrum = !this.todaysScrum ? this.generateNewScrum() : this.todaysScrum;
		},
		mixins: [greetingsMixin],
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				myDailyScrums: 'dailyScrums/myDailyScrums',
				todaysDailyScrumsForMyTeam: 'dailyScrums/todaysDailyScrumsForMyTeam'
			}),
			todaysScrum() {
				const todaysDate = this.$options.filters.formatDate(new Date(), 'YYYY-MM-D');
				var today = this.myDailyScrums.find(x => this.$options.filters.formatDate(x.scrumDateUtc, 'YYYY-MM-D') === todaysDate);
				return today ? today : null;
			},
			lastScrum() {
				if (this.todaysScrum == null) return this.myDailyScrums[0];
				else if (this.myDailyScrums.length >= 2) return this.myDailyScrums[1];
				else return null;
			},
			greetingMessage() {
				return `${this.getGreetingTime()} ${this.loggedInEmployee.firstName}. `;
			}
		},
		methods: {
			onSave(scrum) {
				this.isSubmitting = true;

				if (!this.todaysScrum) {
					scrum.id = this.newGuid();

					this.$store.dispatch('dailyScrums/create', scrum).then(
						response => {
							this.isSubmitting = false;
							this.dailyScrum = this.todaysScrum;
							this.closeEditor();
							this.dailyScrumSavedNotif = true;
						},
						error => {
							this.isSubmitting = false;
						}
					);
				} else {
					this.$store.dispatch('dailyScrums/update', scrum).then(
						response => {
							this.isSubmitting = false;
							this.closeEditor();
							this.dailyScrumSavedNotif = true;
						},
						error => {
							this.isSubmitting = false;
						}
					);
				}
			},
			closeEditor() {
				this.dailyScrumEditorDialog = false;
			},
			onCancel() {
				this.closeEditor();
			},
			generateNewScrum() {
				return {
					id: null,
					scrumDateUtc: new Date().toISOString(),
					employee: {
						id: this.loggedInEmployee.id,
						firstName: this.loggedInEmployee.firstName,
						lastName: this.loggedInEmployee.lastName,
						fullName: this.loggedInEmployee.fullName,
						email: this.loggedInEmployee.email,
						reportsTo: this.loggedInEmployee.reportsTo != null ? this.loggedInEmployee.reportsTo.id : null,
						department: this.loggedInEmployee.department
					},
					items: [
						{
							id: null,
							question: 'What did you do yesterday?',
							answer: null,
							rankType: 0
						},
						{
							id: null,
							question: 'What are your goals for today?',
							answer: null,
							rankType: 0
						},
						{
							id: null,
							question: 'Are there any blockers that stand in your way?',
							answer: null,
							rankType: 0
						}
						// {
						//     id: null,
						//     question: 'How are you feeling today Danny?',
						//     answer: null,
						//     rankType: 2
						// },
					]
				};
			}
		}
	};
</script>

<style scoped>
	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
	}
</style>
